export enum PermissionsEnum {
  ReportsView = 'reports.view',
  RequestsApprove = 'orders.approve',
  DocumentsView = 'documents.view',
  CostsView = 'costs.view',
  Incoming = 'incoming.view',
  Outgoing = 'outgoing.view',
  WorkItems = 'workitems.view',
}

export enum KnownTypes {
  Boolean = 'boolean',
  Number = 'number',
  Bigint = 'bigint',
  String = 'string',
  Symbol = 'symbol',
  Function = 'function',
  Object = 'object',
}

export enum EntityKind {
  Customer = 0x0a,
  Unit = 0xfa,
  Contract = 0x0c,
  Service = 0xcc,
  Vehicle = 0xec,
}

export enum GridColumnKeys {
  OrderId = 'orderId',
  Id = 'id',
  LogisticId = 'logisticId',
  ReturnLogisticId = 'returnLogisticId',
  CompanyName = 'companyName',
  CostCenterName = 'costCenterName',
  InvoiceAddress = 'invoiceAddress',
  ContractState = 'contractState',
  ContractReference = 'contractReference',
  _1320 = '1320',
  CarModel = 'car_model',
  ChassisNr = 'Chassis_NR',
  Insurance = 'insurance',
  InsuranceDoc = 'insurance_doc',
  Registration = 'registration',
  VIN = 'VIN',
  StartDate = 'start_date',
  EarliestDelivery = 'earliest_delivery',
  ConfirmedDelivery = 'confirmed_delivery',
  InvoiceTo = 'InvoiceTo',
  DeliveryTo = 'DeliveryTo',
  DeliveryAddress = 'Delivery_Address',
  TyresDeliveryAddress = 'Tyres_Delivery_Address',
  TyresDeliveryAddress2 = 'Tyres_Delivery_Address2',
  AssignedTo = 'AssignedTo',
  AssignedAt = 'AssignedAt',
  AssignedBy = 'AssignedBy',
  InternalNote = 'InternalNote',
  InternalStatus = 'InternalStatus',
  InvoiceVehicle = 'Invoice_Vehicle',
  CreatedAt = 'createdAt',
  UpdatedAt = 'updatedAt',
  Status = 'status',
  Brand = 'OV003',
  Model = 'OV004',
  ContractReferenceCode = 'OV006',
  LicensePlate = 'OV005',
}
